import JaviReparaWeb from './javirepara';

function App() {
  return <JaviReparaWeb />;
}

export default App;
